import React from 'react';
import './HowItWorksSection.css';

const steps = [
  {
    number: '01',
    title: 'Create Your Profile',
    description: 'Sign up in seconds. Add your basic health information to get started.',
  },
  {
    number: '02',
    // Phase 2: 'Book a Lab Test' step — lab scheduling hidden for Phase 1
    // title: 'Book a Lab Test',
    // description: 'Browse available tests, select a partner lab, and pick a convenient time slot.',
    title: 'Scan or Upload Report',
    description: 'Snap a photo or upload your existing medical documents. Our AI engine extracts and categorises every metric instantly.',
  },
  {
    number: '03',
    title: 'Get Your Reports',
    description: 'Receive digital reports as soon as they\'re ready. View detailed metrics and insights.',
  },
  {
    number: '04',
    title: 'Track Your Health',
    description: 'Monitor your health score, view trends, and get personalized wellness recommendations.',
  },
];

const HowItWorksSection: React.FC = () => {
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">
          Getting started with Wary is simple. Follow these four easy steps.
        </p>

        <div className="how-it-works__steps">
          {steps.map((step, index) => (
            <div key={index} className="how-it-works__step">
              <div className="how-it-works__number">{step.number}</div>
              <div className="how-it-works__connector" />
              <h3 className="how-it-works__step-title">{step.title}</h3>
              <p className="how-it-works__step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
